module.exports = __webpack_public_path__ + "3e276e7d8bcbc157eebf3c34bec19fe5.svg";